import { Collapse, Fab, styled } from '@mui/material'

export const AlertCollapse = styled(Collapse)(({ theme }) => ({
  maxWidth: '100%',
  border: '1px solid',
  position: 'relative',
  backgroundColor: '#fff',
  '& div': {
    padding: 0,
  },
  '& > div': {
    padding: theme.spacing(0.5, 4.3, 1, 1),
  },
}))

export const AlertButtonClose = styled(Fab)(({ theme }) => ({
  position: 'absolute',
  top: 3,
  right: 0,
  backgroundColor: 'transparent',
  boxShadow: 'none',
  height: theme.spacing(4),
  width: theme.spacing(4),
  minHeight: theme.spacing(4),
  '&:hover': {
    backgroundColor: '#F5F5F5',
  },
  '& .MuiSvgIcon-root': {
    height: theme.spacing(2),
    width: theme.spacing(2),
  },
}))
